var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.pathName == '/express/chatbot')?_c('div'):_vm._e(),(_vm.pathName !== '/express/chatbot')?_c('div',{staticClass:"wrapper"},[_c('HeaderSection'),_c('FeatureSection',{staticStyle:{"padding-top":"80px !important"}}),_c('Videoteque'),_c('FAQ'),_c('Partner'),_c('TestimonialThree'),_c('FooterSectionThree')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }